"use strict";

import { addAttributesToOuterLinks, backToTop, anchorScroll } from './common.js';
import { initObservers } from './observers.js';
import { initLenis } from './lenis.js';

function applyPageBackgroundColor() {
    const meta = document.querySelector('meta[name="page-background-color"]');
    const color = meta?.getAttribute('content')?.trim();
    if (color) {
        document.body.style.backgroundColor = color;
    } else {
        document.body.style.removeProperty('background-color');
    }
}

function initCore() {
    initLenis();
    addAttributesToOuterLinks();
    backToTop();
    anchorScroll();
    applyPageBackgroundColor();
    initObservers();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCore, { once: true });
} else {
    initCore();
}
